<template>
  <router-view />
</template>
<script>
export default {
  created() {
    if (
      window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) !=
      "micromessenger"
    ) {
      alert("已禁止本次访问：您必须使用微信内置浏览器访问本页面！");
      var opened = window.open("about:blank", "_self");
      opened.opener = null;
      opened.close();
    }
  },
};
</script>
<style>
body {
  padding: 0;
  margin: 0;
  background: #fff1e2;
}
.nut-input {
  background: #ffffff9e !important;
}
</style>
